export default "/assets/images/mama-room4.png?977bc9c47c0f453453e453b36b1ac170";